// extracted by mini-css-extract-plugin
export default {"root":"G0ifmZ9oFEziQKUn1MMQ","placeHolderShimmer":"m2eylvw5lKftA_3_CJiq"};